
<div class="portal--header">
    <h1 class="heading">
        Device interactions
    </h1>
</div>
<div class="portal--main">
    <div class="btn-group">
        <ng-container *ngFor="let item of typeList">
            <button type="button" (click)="typeListClicked(item)" class="std-btn focus-element subnav-btn" [ngClass]="{'active': item.isClicked }">
                <span class="focus--content" tabindex="-1">
                    <span class="num-wrapper">
                        <span class="num">{{item.count}}</span>
                    </span>{{item.label}}
                </span>
            </button>
        </ng-container>
    </div>
    <form [formGroup]="form" (submit)="submit(form)" autocomplete="off" class="std-form form__search" novalidate>
        <div class="input-addon input-addon__btn-side">
            <label for="search" class="sr-only">Search</label>
            <input type="text" id="search" [formControl]="form.controls['searchTerm']" class="input-addon__btn-side--input" [placeholder]="inputPlaceholder">
            <button type="button" (click)="search()" class="std-btn input-addon__btn-side--btn focus-element"><span class="focus--content" tabindex="-1">Search</span></button>
        </div>
    </form>
    <div class="flex-grid space-between bottom stack-sm">
        <div class="flex-grid--item">
            <button id="toggle-button" class="focus-element" collapsible [collapsibleSection]="collapsibleSection" [collapsibleTitle]="collapsibleTitle"><span class="focus--content" tabindex="-1"><span class='accordion-toggle open' #collapsibleTitle style="margin-top: 0;">Filter <svg class="ic-arrow"><use xlink:href="#ic-arrow" href="#ic-arrow"></use></svg></span></span></button>
            <div class="collapsible" #collapsibleSection>
                <div class="btn-group">
                    <ng-container *ngFor="let button of filterList">
                        <button type="button" (click)="filterButtonClicked(button)" class="std-btn filter active focus-element" [ngClass]="{'active':button.isClicked}">
                            <span class="focus--content" tabindex="-1">{{button.label}} <span class="detail">{{button.count}}</span></span>
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <device-interactions-list-individual  *ngIf="selectedType == 'individual'" [data]="indivdualData"></device-interactions-list-individual>
    <device-interactions-list-multiple *ngIf="selectedType == 'multiple'" [data]="bulkData" (hasCancelled)="getBulkInteraction()"></device-interactions-list-multiple>
    <app-pagination [page]="page" [pages]="totalPages" (pageChange)="pageSelected($event)"></app-pagination>
</div>
